// Hebrew display labels for offer statuses that recruiters must read at a
// glance. Statuses not listed here keep showing their raw name.
export const INTAKE_REVIEW_STATUS = 'awaiting_admin_intake'

export const OFFER_STATUS_LABELS = {
  [INTAKE_REVIEW_STATUS]: 'ממתין לבדיקת יועצת'
}

export function offerStatusLabel (name) {
  return OFFER_STATUS_LABELS[name] || name
}
